import React from 'react';

const SVG = ({
  style = {},
  fill = '#000',
  viewBox = '0 0 24 21.359',
  width = '100%',
  className = '',
  height = '100%',
  ...rest
}) => (
  <svg
    width={width}
    style={style}
    height={height}
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    viewBox={viewBox}
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...rest}
  >
    <g transform="translate(0 -75.92)">
      <g transform="translate(0 75.92)">
        <path
          fill={fill}
          d="M1.176 16.047a1.157 1.157 0 0 1-.816-.307 1.219 1.219 0 0 1-.36-.923V1.383A1.485 1.485 0 0 1 1.488 0H16.7a1.48 1.48 0 0 1 1.464 1.383v9.593a1.48 1.48 0 0 1-1.464 1.383H4.632c-.768 1.207-1.872 2.766-2.064 2.985a1.94 1.94 0 0 1-1.392.703zm.7-2.788c.48-.681 1.1-1.559 1.536-2.217a.951.951 0 0 1 .792-.4h12.139l-.024-8.934H1.824z"
        />
      </g>
      <g transform="translate(5.832 81.232)">
        <path
          fill={fill}
          d="M41.267 40.247a1.969 1.969 0 0 1-1.392-.681c-.168-.176-.888-1.185-2.136-3.007H25.812a1.543 1.543 0 0 1-1.512-1.383V32.52a.9.9 0 0 1 .936-.856.878.878 0 0 1 .912.856v2.349h12.1a.984.984 0 0 1 .792.4c.456.659 1.08 1.537 1.56 2.239V25.912h-2.549a.9.9 0 0 1-.936-.856.885.885 0 0 1 .936-.856h2.9a1.543 1.543 0 0 1 1.512 1.383v13.434a1.087 1.087 0 0 1-.768 1.141 1.015 1.015 0 0 1-.428.089z"
          transform="translate(-24.3 -24.2)"
        />
      </g>
    </g>
  </svg>
);
export default SVG;
